const state = {
  currentAttachBrand: undefined,
  actingBrandId: false,
};

const mutations = {
  setActingBrandId(state, id) {
    state.actingBrandId = id;
  },
  updateCurrentBrand(state, brand) {
    state.currentAttachBrand = brand;
  },
};

const actions = {
  setCurrentBrandData({ commit }, brand) {
    if (brand && brand.brandId) {
      commit('updateCurrentBrand', brand);
      commit('setActingBrandId', brand.brandId);

      window.localStorage.setItem('mmPlatformBrandIdFilter', brand.brandId);
    }
  },
  setDisabledLinks({ rootGetters }) {
    const disabledLinks = [];

    const showDemographics = rootGetters.demographicsDashboardIsAvailable;
    const showSalesInsights = rootGetters.salesDashboardIsAvailable;

    if (!showDemographics) disabledLinks.push('Shopper Intelligence');
    if (!showSalesInsights) disabledLinks.push('Sales Insights');

    window.dispatchEvent(
      new CustomEvent('disabled-links:changed', {
        detail: {
          disabledLinks,
        },
      }),
    );
  },
};

const module = {
  state: state,
  mutations: mutations,
  actions,
};

export default module;
